import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { supabase } from "@/integrations/supabase/client";

type FeatureFlags = Record<string, boolean>;

interface FeatureFlagsContextType {
  flags: FeatureFlags;
  loading: boolean;
  refetch: () => Promise<void>;
}

const FeatureFlagsContext = createContext<FeatureFlagsContextType>({
  flags: {},
  loading: true,
  refetch: async () => {},
});

export function FeatureFlagsProvider({ children }: { children: ReactNode }) {
  const [flags, setFlags] = useState<FeatureFlags>({});
  const [loading, setLoading] = useState(true);

  const fetchFlags = async () => {
    const { data } = await supabase.from("feature_flags").select("flag_key, is_enabled");
    const map: FeatureFlags = {};
    (data ?? []).forEach((f: any) => { map[f.flag_key] = f.is_enabled; });
    setFlags(map);
    setLoading(false);
  };

  useEffect(() => { fetchFlags(); }, []);

  return (
    <FeatureFlagsContext.Provider value={{ flags, loading, refetch: fetchFlags }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

export function useFeatureFlags() {
  return useContext(FeatureFlagsContext);
}

export function useFlag(key: string): boolean {
  const { flags } = useFeatureFlags();
  return flags[key] ?? false;
}
